import * as React from "react";

import AllDevicesContainer from "app/components/AppComponents/Devices/AllDevicesContainer";

export default class List extends React.Component<any, {}> {
  componentDidMount() {
    this.props.setHeader({
      title: "Ops > Devices",
      description: "SnapScan devices"
    });
  }

  render() {
    return (
      <section className="padded">
        <AllDevicesContainer name={"ops.devices.list"} />
      </section>
    );
  }
}
